import React from 'react';
import { Row, Col, FormGroup, Label, Input, Button } from 'reactstrap';

const GuestPartnerForm = ({ 
  partner, 
  index, 
  onInputChange, 
  onFileChange, 
  onRemove,
  fileSizeErrors = {}
}) => {
  const handleFileChange = (fieldName, e) => {
    const file = e.target.files[0];
    if (file) {
      console.log(`Partner ${index} - ${fieldName}:`, {
        name: file.name,
        type: file.type,
        size: file.size
      });
      onFileChange(index, fieldName, file);
    }
  };

  const isFileSelected = (fieldName) => {
    return (
      (partner.files && partner.files[fieldName] instanceof File) || // Check for File object
      (partner[fieldName] && typeof partner[fieldName] === 'string') // Check for URL string
    );
  };

  const getFileValidationMessage = (fieldName) => {
    const errorKey = `${index}_${fieldName}`;
    const fileSizeError = fileSizeErrors[errorKey];
    
    if (fileSizeError) {
      return <small className="text-danger d-block">{fileSizeError}</small>;
    }
    
    if (partner.files && partner.files[fieldName] instanceof File) {
      return <small className="text-success">File selected: {partner.files[fieldName].name}</small>;
    }
    if (partner[fieldName] && typeof partner[fieldName] === 'string') {
      return <small className="text-success">File already uploaded</small>;
    }
    return <small className="text-danger">Please select a file</small>;
  };

  return (
    <div className="guest-partner-form mb-4 p-3 border rounded">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Guest Partner #{index + 1}</h5>
        <Button 
          color="danger" 
          size="sm" 
          onClick={() => onRemove(index)}
        >
          Remove Partner
        </Button>
      </div>

      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Name*</Label>
            <Input
              type="text"
              value={partner.name || ''}
              onChange={(e) => onInputChange(index, 'name', e.target.value)}
              placeholder="Enter partner name"
              required
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Mobile Number*</Label>
            <Input
              type="text"
              value={partner.mobile_number || ''}
              onChange={(e) => onInputChange(index, 'mobile_number', e.target.value)}
              placeholder="Enter mobile number"
              required
              pattern="[0-9]{10}"
              title="Please enter a valid 10-digit mobile number"
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>Gender*</Label>
            <Input
              type="select"
              value={partner.gender || ''}
              onChange={(e) => onInputChange(index, 'gender', e.target.value)}
              required
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Relationship*</Label>
            <Input
              type="text"
              value={partner.relationship || ''}
              onChange={(e) => onInputChange(index, 'relationship', e.target.value)}
              placeholder="Enter relationship"
              required
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <FormGroup>
            <Label>ID Proof Type*</Label>
            <Input
              type="select"
              value={partner.id_proof_type || ''}
              onChange={(e) => onInputChange(index, 'id_proof_type', e.target.value)}
              required
            >
              <option value="">Select ID Proof</option>
              <option value="aadhar">Aadhar Card</option>
              <option value="passport">Passport</option>
              <option value="driving">Driving License</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={4}>
          <FormGroup>
            <Label>ID Proof Front*</Label>
            <Input
              type="file"
              onChange={(e) => handleFileChange('id_proof_front', e)}
              accept="image/*"
              className="form-control"
              required={!isFileSelected('id_proof_front')}
            />
            {getFileValidationMessage('id_proof_front')}
            {partner.id_proof_front && typeof partner.id_proof_front === 'string' && (
              <div className="mt-1">
                <a href={partner.id_proof_front} target="_blank" rel="noopener noreferrer" className="text-primary">
                  View Current File
                </a>
              </div>
            )}
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>ID Proof Back*</Label>
            <Input
              type="file"
              onChange={(e) => handleFileChange('id_proof_back', e)}
              accept="image/*"
              className="form-control"
              required={!isFileSelected('id_proof_back')}
            />
            {getFileValidationMessage('id_proof_back')}
            {partner.id_proof_back && typeof partner.id_proof_back === 'string' && (
              <div className="mt-1">
                <a href={partner.id_proof_back} target="_blank" rel="noopener noreferrer" className="text-primary">
                  View Current File
                </a>
              </div>
            )}
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Partner Photo*</Label>
            <Input
              type="file"
              onChange={(e) => handleFileChange('partner_photo', e)}
              accept="image/*"
              className="form-control"
              required={!isFileSelected('partner_photo')}
            />
            {getFileValidationMessage('partner_photo')}
            {partner.partner_photo && typeof partner.partner_photo === 'string' && (
              <div className="mt-1">
                <a href={partner.partner_photo} target="_blank" rel="noopener noreferrer" className="text-primary">
                  View Current File
                </a>
              </div>
            )}
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
};

export default GuestPartnerForm; 